/**
 * Underline-style tabs: a bottom border on the list, with the active trigger
 * drawing a thicker primary underline instead of the default pill background.
 *
 * The `Tabs` primitive has no cva variants — its single hardcoded default IS
 * the pill look — so every underline surface has to neutralise the same six
 * classes (`rounded-none`, `bg-transparent`, `p-0`,
 * `data-[state=active]:bg-transparent`, `data-[state=active]:shadow-none`).
 * These two constants are that neutralisation, written once. They started life
 * in `modules/knowledge-management/documents/utils/tab-styles.ts`, copied from
 * the analytics-v2 surface; they live here because four modules now share them.
 *
 * Deliberately NO weight change on the active trigger: it differs from an
 * inactive one by colour (`text-primary` vs `text-tertiary-dark-green`) and the
 * 2px underline only, both keeping the primitive's base `font-medium`. That is
 * what `modules/analytics/analytics-v2-app.tsx` renders, and matching it means
 * not adding `font-semibold` here.
 */
export const UNDERLINE_TABS_LIST =
    "h-auto justify-start gap-0 rounded-none border-b border-primary-subtle2 bg-transparent p-0"

export const UNDERLINE_TABS_TRIGGER =
    "-mb-px rounded-none border-b-2 border-transparent px-4 py-3 text-tertiary-dark-green data-[state=active]:border-primary data-[state=active]:bg-transparent data-[state=active]:text-primary data-[state=active]:shadow-none"
